import NiceModal, { useModal } from '@ebay/nice-modal-react'
import UnmarkPurchaseModal from 'src/routes/(registry)/registry/(gift-tracker-revamp)/components/UnmarkPurchaseModal'
import QuantityCallout from 'src/routes/(registry)/registry/(gift-tracker-revamp)/components/UnmarkPurchaseModal/components/QuantityCallout'
import { Reservation } from 'src/types/reservation'
import useGetRegistry from 'src/routes/(subdomains)/(my)/[slug]/hooks/useGetRegistry'
import { showUnmarkedAsPurchasedToast } from 'src/routes/(registry)/registry/(gift-tracker-revamp)/components/GiftDetailsDrawer/UnmarkedAsPurchasedToast'
import css from './UnmarkRegItemPurchaseModal.styles.scss'
import { UnmarkRegItemPurchaseModalProps } from './UnmarkRegItemPurchaseModal.types'

const UnmarkRegItemPurchaseModal = NiceModal.create(
  ({ reservation }: UnmarkRegItemPurchaseModalProps) => {
    const modal = useModal()
    const { registry } = useGetRegistry(reservation.registryId.toString())

    const resolveModal = (res?: Reservation) => {
      modal.resolve(res)
      modal.hide()
    }

    const handleUnmarkedAsPurchased = (res: Reservation) => {
      showUnmarkedAsPurchasedToast(registry)
      resolveModal(res)
    }

    const handleClose = () => resolveModal()

    return (
      <UnmarkPurchaseModal
        handleClose={handleClose}
        handleDismount={modal.remove}
        isOpen={modal.visible}
        reservation={reservation}
        onUnmarkedAsPurchased={handleUnmarkedAsPurchased}
      >
        <p className={css.UnmarkRegItemPurchaseModal__Body}>
          Here's what you need to know:
        </p>
        <ol className={css.UnmarkRegItemPurchaseModal__NumberedList}>
          <li>This gift will become available on your registry again.</li>
          <li>
            This gift will be removed from your gift tracker and thank you list.
          </li>
        </ol>
        <QuantityCallout />
      </UnmarkPurchaseModal>
    )
  }
)

export default UnmarkRegItemPurchaseModal
